export const socialProofData = [
  {
    quote: "Sage has completely changed how our family eats! Meal planning used to take me hours every Sunday, but now I get personalized weekly plans in seconds. My kids are eating healthier and we're saving so much time on grocery shopping.",
    name: "Jennifer Martinez",
    title: "Mother of three, Austin TX", 
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=64&h=64"
  },
  {
    quote: "I never thought meal planning could be this easy! Sage creates perfect shopping lists and my whole family loves the healthy recipes. We're eating better than ever and I get 3 hours back every week that I used to spend planning meals.",
    name: "David Thompson", 
    title: "Working dad, Denver CO",
    avatar: "https://images.unsplash.com/photo-1556474835-b0f3ac40d4d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=64&h=64"
  },
  {
    quote: "Sage is a game-changer for busy families! The app makes grocery shopping so fast and easy. My family is healthier, happier, and I actually enjoy cooking again. It's like having a personal nutritionist and chef rolled into one.",
    name: "Maria Gonzalez",
    title: "Nurse and mom, Phoenix AZ", 
    avatar: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=64&h=64"
  }
];
